"use strict";
import MainMenuController from "src/decidim/controllers/main_menu/controller";
export default class extends MainMenuController {
  handleButtonClick() {
    if (!this.isHidden()) {
      return;
    }
    setTimeout(() => this.openMenu(), 50);
  }
}
